import React from 'react';
import { Link } from 'react-router-dom';
import './newsheader.css';

const NewsHeader = () => {
    return (
        <div className="news-header">
            <div className="news-header-content">
                <div className="text-container">
                    <div className='header-h1'>
                        <h1>Nyheter från <span className='green-h1'>Cycle Solutions</span></h1>
                    </div>
                    <p>
                        Här hittar du de senaste uppdateringarna och nyheterna om våra balpressar och komprimatorer.
                        Vi strävar efter att ge dig den bästa lösningen för avfallshantering och återvinning.
                    </p>
                    <p className="news-header-sub">
                        Läs guider om hur du väljer rätt maskin, tips för bättre sortering och kundcase från
                        företag som har effektiviserat sin avfallshantering med balpressar och komprimatorer från Bramidan Presto.
                    </p>
                    <nav className="news-header-links" aria-label="Genvägar">
                        <Link to="/produkter/balpressar">Balpressar</Link>
                        <Link to="/produkter/komprimatorer">Komprimatorer</Link>
                        <Link to="/vanliga-fragor">Vanliga frågor</Link>
                        <Link to="/kontakt">Kontakta oss</Link>
                    </nav>
                </div>
                <hr className="line-separator" />
            </div>
        </div>
    );
};

export default NewsHeader;
